import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeAeroPhotoModal } from '../../actions/aeroPhotoTour';
import { AeroPhotoTourFrame } from '../../components/AeroPhotoTourFrame';
import { getIsAeroPhotoTourOpen } from '../../selectors/aeroPhotoTour';
import { getAeroPhotoTourLink } from '../../selectors/newbuilding';
import { ModalWithContactsContainer } from '../ModalWithContacts';

export const AeroPhotoTourModalContainer = () => {
  const isOpen = useSelector(getIsAeroPhotoTourOpen);
  const url = useSelector(getAeroPhotoTourLink);
  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(closeAeroPhotoModal());
  }, [dispatch]);

  if (!url) {
    return null;
  }

  return (
    <ModalWithContactsContainer open={isOpen} onClose={handleClose} placeType="airphoto">
      <AeroPhotoTourFrame url={url} />
    </ModalWithContactsContainer>
  );
};
